export enum EventBusEnum {
  SPAM_USER_EXCEPTION = "noRolesException",
  CHARGING_STATION_CREATED = "chargingStationCreated"
}
